export default {
  namespaced: true,

  state: {
    selectedBrandIds: [],
    selectedColorIds: [],
  },

  mutations: {
    // Don't manually call this mutation, use the action instead.
    toggleSelectedBrandId(state, brandId) {
      if (state.selectedBrandIds.includes(brandId)) {
        state.selectedBrandIds = state.selectedBrandIds.filter(
          (id) => id !== brandId
        );
      } else {
        state.selectedBrandIds.push(brandId);
      }
    },

    // Don't manually call this mutation, use the action instead.
    toggleSelectedColorId(state, colorId) {
      if (state.selectedColorIds.includes(colorId)) {
        state.selectedColorIds = state.selectedColorIds.filter(
          (id) => id !== colorId
        );
      } else {
        state.selectedColorIds.push(colorId);
      }
    },
    resetFilters(state) {
      state.selectedBrandIds = [];
      state.selectedColorIds = [];
    },
  },

  actions: {
    toggleSelectedBrandId({ commit, state, rootState }, brandId) {
      commit('toggleSelectedBrandId', brandId);

      // De-select every color that is not available for every selected brand.
      state.selectedColorIds
        .filter((colorId) => {
          return !state.selectedBrandIds.every((selectedBrandId) => {
            return rootState['brand-color-selection'].lines.find((line) => {
              return (
                line.brand_id === selectedBrandId && line.color_id === colorId
              );
            });
          });
        })
        .forEach((colorId) => {
          commit('toggleSelectedColorId', colorId);
        });
    },

    toggleSelectedColorId({ commit, state, rootState }, colorId) {
      commit('toggleSelectedColorId', colorId);

      // De-select every brand that is not available for every selected color.
      state.selectedBrandIds
        .filter((brandId) => {
          return !state.selectedColorIds.every((selectedColorId) => {
            return rootState['brand-color-selection'].lines.find((line) => {
              return (
                line.color_id === selectedColorId && line.brand_id === brandId
              );
            });
          });
        })
        .forEach((brandId) => {
          commit('toggleSelectedBrandId', brandId);
        });
    },
  },
};
